/*
 * Get-products.ts
 * Description: Includes the declaration
 * of the function for getting a list of products
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing Vuex
import {store} from '@/config/plugins';
// Importing Normalization function
import normalize from 'normalize-json-api-response';

/**
 * Getting a list of products
 *
 * @return {Object} Promise - a list of products
 * @param {String} slug - id of a restaurant
 * @param {Number} categoryId - id of a category that we
 * want to get products from
 */
export function getProducts(slug: string, categoryId: number = Number()) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/products',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            params: {
                menu_category: categoryId,
                page: store.getters.currentPage,
                order_by: store.getters.orderParam,
                sort_by: store.getters.sortParam,
                query: store.getters.queryParam,
            },
            data: {},
        }).then((response) => {
            // Assigning the data array to users
            store.dispatch('setResponse', response.data.data);
            store.dispatch('setLastPage', response.data.meta.last_page);
            resolve(normalize(response.data));
        }).catch(() => {
            reject();
        });
    });
}
